import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
})
export default class DatetimeField extends Vue {
    @Prop ({ type: String }) displayName!: string;
    @Prop({ type: String }) fieldValue!: string;
}